var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sort_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-2-2h18v18H-2z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sort_svg__a)",
    "data-name": "Scroll Group 79",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    transform: "translate(2 2)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0eb948",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Group 4066"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.723 13.004V2.578",
    "data-name": "Path 18995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.844 9.868 10.723 13 7.601 9.864",
    "data-name": "Path 18996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.121.501v10.425",
    "data-name": "Path 18997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.001 3.637 3.121.5l3.122 3.137",
    "data-name": "Path 18998"
  })))));
};
export default SvgSort;